export default {
      id: "play-usage",
      viewBox: "0 0 17 19",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#play",
      toString: function () {
        return this.url;
      }
    }